import styled from 'styled-components';
export const ModalOverlay = styled.div `
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
export const StyledModal = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.getColor('white')};
  border-radius: 1.2rem;
  padding: 2.4rem;
  min-width: 50rem;
`;
export const ModalImage = styled.div `
  display: flex;
  justify-content: center;
  margin-bottom: 2.4rem;
`;
export const ModalContent = styled.div `
  width: 100%;
  margin-bottom: 3.2rem;
`;
export const ModalTitle = styled.h2 `
  color: ${({ theme, $type }) => {
    switch ($type) {
        case 'success':
            return theme.getColor('primary', 'default');
        case 'error':
            return theme.getColor('error', 'default');
        case 'alert':
        case 'warning':
            return theme.getColor('warning', 'default');
    }
}};

  ${({ theme }) => theme.getFontStyle('samsung-700-24')};
  text-align: center;
  margin-bottom: 1rem;
`;
export const ModalDescriptionList = styled.ul `
  ${({ theme }) => theme.getFontStyle('samsung-400-14')};
  color: ${({ theme }) => theme.getColor('gray', '02')};
  padding: 0 2.4rem;
  list-style: disc;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
`;
export const ModalDescriptionItem = styled.li `
  white-space: pre-line;
`;
export const ModalAddContentWrapper = styled.div `
  margin-top: 1.2rem;
`;
export const ModalButtonContainer = styled.div `
  display: flex;
  width: 100%;
  column-gap: 0.8rem;
`;
//# sourceMappingURL=Modal.styles.js.map